import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_DUPLICATES_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { loadDuplicatesCountRequest } from 'reactApp/modules/duplicates/duplicates.actions';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export const useDuplicatesCount = () => {
    const dispatch = useDispatch();

    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const isQuotaLoaded = useSelector(UserQuotaSelectors.isQuotaLoaded);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isB2BUser = useSelector(UserSelectors.isB2BUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    const duplicatesEnabled = IS_DUPLICATES_ENABLED && !isOverquota && isQuotaLoaded && !isBizUser && !isB2BUser;
    const showDuplicatesPromo = !isCorpUser && !isPaidUser;
    const callDuplicatesCount = duplicatesEnabled && showDuplicatesPromo;

    useEffect(() => {
        if (callDuplicatesCount) {
            dispatch(loadDuplicatesCountRequest());
        }
    }, [dispatch, callDuplicatesCount]);
};
